import React from 'react';
import { connect } from 'react-redux';
import { AvForm, AvInput } from 'availity-reactstrap-validation';
import { Button, Col, FormText, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

import { IRootState } from 'app/shared/reducers';
import { uploadFile } from './tenant.reducer';
import { defaultValue } from '../../shared/model/tenant.model';

export interface IUploadFiletUpdateProps extends StateProps, DispatchProps {}

export interface IUploadFileUpdateState {
  modal: boolean;
  error: boolean;
  file: any;
}

export interface IUploadFiletUpdateProps {
  buttonLabel: string;
}

export class UploadFileModal extends React.Component<IUploadFiletUpdateProps, IUploadFileUpdateState> {
  state: IUploadFileUpdateState = {
    modal: false,
    error: false,
    file: ''
  };

  handleInvalidSubmit = (event, errors, values) => {
    this.setState({ error: true });
  };

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  };

  handleChange = e => {
    this.setState({ file: e.target.files[0] });
  };

  handleValidSubmit = e => {
    e.preventDefault();
    const file = this.state.file;
    this.props.uploadFile(file);

    // this.toggle();
  };

  render() {
    //    const savedDevices = this.props.savedDevices;
    return (
      <div>
        <Button color="danger" onClick={this.toggle}>
          {this.props.buttonLabel}
        </Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Choose file to upload!</ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={this.handleValidSubmit} onInvalidSubmit={this.handleInvalidSubmit}>
              <Row>
                <Col>
                  <AvInput className="" name="file" type="file" onChange={this.handleChange} required />
                </Col>
              </Row>
              <Row>
                <Col className="btn-group flex-btn-group-container text-right">
                  <Button color="primary">Import</Button>
                  <Button color="secondary" onClick={this.toggle}>
                    Cancel
                  </Button>
                </Col>
              </Row>
            </AvForm>
          </ModalBody>

          <div>
            {this.props.savedResponse !== defaultValue && (
              <React.Fragment>
                <FormText className="modal-message-upload-file">
                  {this.props.savedResponse.savedDevices !== null
                    ? 'Devices successfully imported: ' + this.props.savedResponse.savedDevices
                    : null}
                </FormText>
                <FormText className="modal-message-upload-file">
                  {this.props.savedResponse.alreadyImported !== null
                    ? 'Devices already imported: ' + this.props.savedResponse.alreadyImported
                    : null}
                </FormText>
                <FormText className="modal-message-upload-file">
                  {this.props.savedResponse.failedDevices !== null
                    ? 'Could not insert the following devices: ' + this.props.savedResponse.failedDevices
                    : null}
                </FormText>
                <FormText className="modal-message-upload-file">
                  {this.props.savedResponse.alreadyRegistered !== null
                    ? 'Devices already registered: ' + this.props.savedResponse.alreadyRegistered
                    : null}
                </FormText>
              </React.Fragment>
            )}
          </div>
          <ModalFooter />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  savedResponse: storeState.tenant.savedResponse
});

const mapDispatchToProps = {
  uploadFile
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadFileModal);
